export default{
    lang:"cn",
    classLang:"cn",
    fontFamily:"cn-font-family",
    fontFamilyTitle:"cn-font-family-title",
    requestLang:"zh_CN",
    type: "cn",
}